import Phaser from 'phaser';

/**
 * GemPickup FX — wizualny feedback zdobycia kryształów 💎 (Etap 5.0 polish).
 *
 * Gemy są kredytowane SERVER-SIDE (drop z kryształów rollowany w `/world/tick`,
 * 5.0.B). Klient NIE zna kwoty w momencie zniszczenia — dowiaduje się z
 * odpowiedzi ticka. Dlatego FX odpalany jest z eventu `gems:earned` (delta z
 * AutoSaveBridge), przy graczu, jako czysta animacja — kilka diamentów
 * wystrzeliwuje w górę + tekst „+N". Liczba diamentów capowana (czytelność).
 *
 * Proceduralny kształt (polygon), spójnie z monetami (`Coin` to `add.circle`,
 * też bez PNG). Kolor = róż gema (matchuje `ui_gem.png` + fioletowy licznik HUD).
 */

const GEM_FILL = 0xff6fae;   // róż jak ui_gem.png
const GEM_STROKE = 0xc23a78; // ciemniejszy kontur

/** Punkty diamentu (top, right, bottom, left) względem środka. */
function diamondPoints(r: number): number[] {
  return [0, -r * 1.3, r, 0, 0, r * 1.3, -r, 0];
}

export function spawnGemPickup(
  scene: Phaser.Scene,
  x: number,
  y: number,
  amount: number,
): void {
  if (amount <= 0) return;
  const n = Math.max(1, Math.min(amount, 5)); // cap wizualny

  for (let i = 0; i < n; i++) {
    const r = Phaser.Math.Between(6, 9);
    const gem = scene.add.polygon(x, y, diamondPoints(r), GEM_FILL).setDepth(70);   // > AtmosphereSystem vignette (62) — feedback zbierania czytelny nad światłem
    gem.setStrokeStyle(2, GEM_STROKE);

    // Głównie w górę, lekki rozrzut.
    const angle = -Math.PI / 2 + (Math.random() - 0.5) * 1.4;
    const dist = Phaser.Math.Between(28, 60);
    scene.tweens.add({
      targets: gem,
      x: x + Math.cos(angle) * dist,
      y: y + Math.sin(angle) * dist,
      angle: Phaser.Math.Between(-40, 40),
      duration: 520,
      delay: i * 45,
      ease: 'Cubic.easeOut',
      onComplete: () => {
        scene.tweens.add({
          targets: gem,
          alpha: 0,
          scale: 0.3,
          duration: 220,
          onComplete: () => gem.destroy(),
        });
      },
    });
  }

  // Floating "+N" — różowy, spójny z kolorem gema.
  const text = scene.add
    .text(x, y - 14, `+${amount}`, {
      fontFamily: 'Baloo 2, sans-serif',
      fontSize: '22px',
      color: '#FF6FAE',
      stroke: '#000000',
      strokeThickness: 4,
      fontStyle: 'bold',
    })
    .setOrigin(0.5)
    .setDepth(71);   // nad gemami (70) i atmosferą (62)
  scene.tweens.add({
    targets: text,
    y: y - 56,
    alpha: 0,
    duration: 900,
    ease: 'Cubic.easeOut',
    onComplete: () => text.destroy(),
  });
}
